module.exports = __webpack_public_path__ + "static/img/3.7ecc6c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/3.png
// module id = K7/n
// module chunks = 0